import { render, staticRenderFns } from "./ProcessNewCollection.vue?vue&type=template&id=0453aa32&"
import script from "./ProcessNewCollection.vue?vue&type=script&lang=js&"
export * from "./ProcessNewCollection.vue?vue&type=script&lang=js&"
import style0 from "./ProcessNewCollection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports